module.exports = __webpack_public_path__ + "static/img3-7eb5b442a64bcbabc3d07093554a11a9.jpg";